import React from 'react'
import { AppContext } from '../../context'
import Slide from '../ui/Slide'

const RasterPopover: React.FC = () => {
  const subscriptionUrl = `${process.env.REACT_APP_SUBSCRIPTIONS_URL}booksSubscriptions/`

  return (
    <AppContext.Consumer>
      {({ activePopover, onTogglePopover }) => (
        <Slide
          id="raster-charts-overlay"
          className="card border-light overlay overlay-right"
          isVisible={activePopover === 'raster'}
        >
          <div id="">
            <h4>You're in a free trial</h4>
            <span>To access Imray raster charts, join Explore as a member</span>
            <br />
            <a
              id="raster-charts-overlay-subscribe-button"
              className="btn btn-primary"
              target="_blank"
              href={subscriptionUrl}
              onClick={() => onTogglePopover('')}
            >
              Join
            </a>
          </div>
        </Slide>
      )}
    </AppContext.Consumer>
  )
}

export default RasterPopover
